import { Constants } from "../constants/Contants";
import request from "../utils/useApi";
// import { toast } from "react-toastify";
import { get, post } from '../utils/request';

export const signup = async (data) => {
  try {
    const res = await request.post(Constants.signup_api_url, data);
    if (res) {
      return res.data;
    }
  } catch (e) {
    // toast.error(e.message);
    throw e;
  }
};

export const signIn = async (data) => {
  try {
    const res = await request.post(Constants.signin_api_url, data);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};

export const sendEmailOTP = async (email) => {
  try {
    await post(Constants.sentEmailOTP, {email});
    return true;
  } catch (error) {
    console.error("Failed to send email:", error);
    return false;
  }
};

export const updateUserProfile = async (data) => {
  try {
    await post(Constants.updateUserProfile, data);
    return true;
  } catch (error) {
    console.error("Failed to send email:", error);
    return false;
  }
};
